export const state = () => ({
  show: false,
  query: '',
})

export const mutations = {
  SET_SHOW(store, is) {
    store.show = is;
  },
  SET_FILTER_QUERY(store, query) {
    store.query = query;
  },
}

export const getters = {
  searchMod: state => Boolean(state.query),
};

export const actions = {};
